import { FormattedMessage } from 'react-intl';
import type useUser from '@alltrails/context/hooks/useUser';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';

type Params = {
  tier: PurchaseTier;
  user: ReturnType<typeof useUser>;
};

// CTA copy for every upsell modal. Deliberately separate from the plans landing page CTA, which advertises
// an applicable coupon ahead of promo eligibility and is free to diverge further.
export default function getUpsellCtaText({ tier, user }: Params) {
  if (user?.isPromoEligible) {
    return <FormattedMessage defaultMessage="Start your free trial" />;
  }

  if (tier === 'peak') {
    // Trialing subscribers have no remaining paid time to refund, so they are not treated as upgrades.
    if (user?.canUpgradeExistingSubscription && !user?.subscription?.trial) {
      return <FormattedMessage defaultMessage="Upgrade to Peak" />;
    }

    return <FormattedMessage defaultMessage="Continue with Peak" />;
  }

  return <FormattedMessage defaultMessage="Continue with Plus" />;
}
